import * as React from "react";
import { Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import * as analytics from "@/services/analytics";
import { BUSINESS_REPORT_OUTCOME_EXPORT_OPTIONS, getBusinessReportOutcomeExportUrl } from "./export.utils";

interface BusinessReportOutcomeExportProps {
  businessReportOutcomeId: string;
}

export const BusinessReportOutcomeExport: React.FC<BusinessReportOutcomeExportProps> = ({
  businessReportOutcomeId,
}) => {
  const handleClick = () => {
    analytics.snapshotExport();
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Download className="mr-1.5 size-4" />
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {BUSINESS_REPORT_OUTCOME_EXPORT_OPTIONS.map(option => (
          <DropdownMenuItem key={option.format}>
            <a href={getBusinessReportOutcomeExportUrl(businessReportOutcomeId, option.format)} onClick={handleClick}>
              {option.label}
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
